{
  "de": {
    "task": {
      "actions": {
        "create": "Aufgabe",
        "update": "Aufgabe bearbeiten"
      },
      "attributes": {
        "assignments_count": "Zuweisungen",
        "category": "Kategorie",
        "created_at": "Erstellt",
        "description": "Beschreibung",
        "title": "Titel",
        "units": "Einheiten"
      },
      "categories": {
        "confirmation": "Bestätigung",
        "upload": "Hochladen"
      },
      "labels": {
        "no_tasks": "Noch keine Aufgaben für dieses Projekt.",
        "required": "Dieses Feld ist erforderlich",
        "units_required": "Wählen Sie mindestens eine Einheit aus"
      },
      "toasts": {
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
